export default __webpack_public_path__ + "static/media/dai.47bb529d.svg";